export const Eagers = {
    stretch: '[includedExtras.[extra], afiliatePrices, afiliatePassengerCategories, primaryMoney, tax,  operationLine.[businessUnit], prices.[passengerCategory], vueltaPrices.[passengerCategory]]',
    packet: '[primaryMoney, tax,  operationLine.[businessUnit], stretches.[operationLine.[businessUnit]], prices.[passengerCategory]]',
};



//////////////////
// WEBPACK FOOTER
// ./src/helpers/Eagers.ts
// module id = 243
// module chunks = 0